module.exports = __webpack_public_path__ + "static/media/right-arrow.1ee4c3ee.svg";